import loadable from '@loadable/component';

const QuoteConfirmation = loadable(
  () => import(/* webpackChunkName: "quote-confirmation" */ './quote-confirmation/quote-confirmation-component'),
  {
    resolveComponent: (components) => components.QuoteConfirmation,
  }
);

const QuoteConfirmationHeader = loadable(
  () => import(/* webpackChunkName: "quote-confirmation" */ './quote-confirmation-header/quote-confirmation-header-component'),
  {
    resolveComponent: (components) => components.QuoteConfirmationHeader,
  }
);

export { QuoteConfirmation, QuoteConfirmationHeader };
